import React, { useEffect } from 'react';
import { Col, Form, Input, Row, Radio, Select, InputNumber, DatePicker } from 'antd';

import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash';
import CustomTextInput from 'components/inputs/CustomTextInput';

const userCategoryList = [
	{
		label: 'Position',
		value: 'positions',
	},
	{
		label: 'Employee',
		value: 'users',
	},
	{
		label: 'Process Role',
		value: 'processRoles',
	},
];

function HistoryCom({ historyData, isSuccess, dataList, roleList }) {
	const [form] = Form.useForm();

	useEffect(() => {
		if (historyData) {
			// create new committee with personName
			const committeeTemp = historyData?.committeeMembers?.map((item) => {
				let personName = '';
				let positionType = '';

				if (item?.positionType === 'employee') {
					positionType = userCategoryList?.find((item) => item?.value === 'users')?.label ?? '';
					const personObj = dataList?.users?.find((itemFilter) => itemFilter?.value === item?.positionValue);

					if (!isEmpty(personObj)) {
						personName = personObj?.userFullName;
					}
				} else if (item?.positionType === 'processRole') {
					positionType = userCategoryList?.find((item) => item?.value === 'processRoles')?.label ?? '';
					const personObj = dataList?.processRoles?.find((itemFilter) => itemFilter?.value === item?.positionValue);
					if (!isEmpty(personObj)) {
						personName = personObj?.userFullName;
					}
				} else if (item?.positionType === 'position') {
					positionType = userCategoryList?.find((item) => item?.value === 'positions')?.label ?? '';
					const personObj = dataList?.positions?.find((itemFilter) => itemFilter?.value === item?.positionValue);
					if (!isEmpty(personObj)) {
						personName = personObj?.userFullName;
					}
				}

				return {
					...item,
					personName,
					nominatedAs: positionType,
				};
			});

			// process secretary members
			let personName = '';
			let positionType = '';

			if (historyData?.secretaryMembers?.positionType === 'employee') {
				positionType = userCategoryList?.find((item) => item?.value === 'users')?.label ?? '';
				const personObj = dataList?.users?.find((itemFilter) => itemFilter?.value === historyData?.secretaryMembers?.positionValue);

				if (!isEmpty(personObj)) {
					personName = personObj?.userFullName;
				}
			} else if (historyData?.secretaryMembers?.positionType === 'processRole') {
				positionType = userCategoryList?.find((item) => item?.value === 'processRoles')?.label ?? '';
				const personObj = dataList?.processRoles?.find((itemFilter) => itemFilter?.value === historyData?.secretaryMembers?.positionValue);
				if (!isEmpty(personObj)) {
					personName = personObj?.userFullName;
				}
			} else if (historyData?.secretaryMembers?.positionType === 'position') {
				positionType = userCategoryList?.find((item) => item?.value === 'positions')?.label ?? '';
				const personObj = dataList?.positions?.find((itemFilter) => itemFilter?.value === historyData?.secretaryMembers?.positionValue);
				if (!isEmpty(personObj)) {
					personName = personObj?.userFullName;
				}
			}

			const secretaryMembersTemp = {
				personName,
				nominatedAs: positionType,
			};

			form.setFieldsValue({
				...historyData,
				holdingTime: historyData?.quorumTime,
				holdingTimeUnit: historyData?.quorumTimeUnit,
				// fromDate: dayjs(historyData?.fromDate),
				committeeMembers: committeeTemp,
				committeeSecretary: [secretaryMembersTemp],
				toDate: historyData?.toDate ?? historyData?.editedDate?.localDateTimeString,
			});
		}
	}, [historyData]);

	return (
		<>
			{isSuccess && (
				<>
					{/* <MainCard sx={{ mt: 0 }}> */}
					<Form form={form} id="coe-committee" layout="vertical" autoComplete="off" requiredMark={false} disabled>
						<Row gutter={[16, 0]}>
							{/* <Col xs={12} sm={6}>
								<Form.Item label="Effective form" name="fromDate">
									<DatePicker style={{ width: '100%' }} />
								</Form.Item>
							</Col>
							<Col xs={12} sm={6}>
								<Form.Item label="To Date" name="toDate">
									<DatePicker style={{ width: '100%' }} />
								</Form.Item>
							</Col>

							<Col xs={24} sm={24} md={24} xl={24}>
								<Form.Item label="Committee name" name="title">
									<Input />
								</Form.Item>
							</Col>

							<Col xs={24} sm={24} md={24} xl={24}>
								<Form.Item label="Details" name="purpose">
									<Input />
								</Form.Item>
							</Col>

							<Col xs={24}>
								<MainCard content={false} sx={{ overflowX: 'auto', width: '100%', mb: 2 }}>
									<Form.List name="committeeMembers">
										{(fields, fieldsOpt) => (
											<TableContainer
												sx={{
													width: '100%',
													overflowX: 'auto',
													position: 'relative',
													display: 'block',
													'& td, & th': { whiteSpace: 'nowrap' },
													'& td': {
														borderTop: '0px',
														borderLeft: '0px',
														borderBottom: '0px',
													},
													'& td:not(:last-child)': {
														borderRight: '1px solid #e0e0e0',
													},
													'& tr:not(:last-child)': {
														borderBottom: '1px solid #e0e0e0',
													},
													'& th': {
														borderBottom: '1px solid #e0e0e0',
													},
												}}
											>
												<Table
													aria-labelledby="solutionTaskTable"
													sx={{
														// tableLayout: 'fixed',
														width: '100%',
														'& .MuiTableBody-root .MuiTableCell-root': {
															p: 0.5,
														},
														'& .MuiTableHead-root .MuiTableCell-root': {
															py: 0.5,
															px: 1,
														},
														'& .ant-form-item': {
															marginBottom: 0,
														},
													}}
												>
													<TableHead>
														<TableRow sx={{ backgroundColor: '#e5e5e5' }}>
															<TableCell sx={{ minWidth: '100px', width: '8%' }}>Sequel</TableCell>
															<TableCell sx={{ minWidth: '180px', width: '18%' }} align="center">
																Committee
															</TableCell>
															<TableCell sx={{ minWidth: '150px', width: '12%' }} align="center">
																Nominated as
															</TableCell>
															<TableCell sx={{ minWidth: '150px', width: '12%' }} align="center">
																Role
															</TableCell>
															<TableCell sx={{ minWidth: '120px', width: '10%' }} align="center">
																Voting Right
															</TableCell>
															<TableCell sx={{ minWidth: '120px', width: '10%' }} align="center">
																Is Voting Must?
															</TableCell>
															<TableCell sx={{ minWidth: '120px', width: '10%' }} align="center">
																Voting Score
															</TableCell>
														</TableRow>
													</TableHead>
													<TableBody>
														{fields?.map((field, index) => (
															<TableRow key={index}>
																<TableCell align="center">
																	<Form.Item name={[field.name, 'serial']}>
																		<InputNumber style={{ width: '100%' }} disabled />
																	</Form.Item>
																</TableCell>

																<TableCell align="center">
																	<Form.Item name={[field.name, 'personName']} style={{ margin: 0, flex: 1 }}>
																		<Input placeholder="Person name" disabled />
																	</Form.Item>
																</TableCell>

																<TableCell align="center">
																	<Form.Item name={[field.name, 'nominatedAs']}>
																		<Input disabled />
																	</Form.Item>
																</TableCell>

																<TableCell align="center">
																	<Form.Item
																		name={[field.name, 'positionName']}
																		rules={[{ required: true, message: 'Required' }]}
																	>
																		<Select
																			allowClear
																			showSearch
																			style={{ width: '100%' }}
																			placeholder="Select"
																			options={roleList}
																			disabled
																		/>
																	</Form.Item>
																</TableCell>

																<TableCell align="center">
																	<Form.Item name={[field.name, 'canVote']}>
																		<Select
																			allowClear
																			showSearch
																			style={{ width: '100%' }}
																			placeholder="Select"
																			options={[
																				{ label: 'Yes', value: 'yes' },
																				{ label: 'No', value: 'no' },
																			]}
																			disabled
																		/>
																	</Form.Item>
																</TableCell>

																<TableCell align="center">
																	<Form.Item name={[field.name, 'isMandatory']}>
																		<Select
																			allowClear
																			showSearch
																			style={{ width: '100%' }}
																			placeholder="Select"
																			options={[
																				{ label: 'Yes', value: 'yes' },
																				{ label: 'No', value: 'no' },
																			]}
																			disabled
																		/>
																	</Form.Item>
																</TableCell>

																<TableCell align="center">
																	<Form.Item name={[field.name, 'points']} style={{ margin: 0, flex: 1 }}>
																		<Input disabled />
																	</Form.Item>
																</TableCell>
															</TableRow>
														))}
													</TableBody>
												</Table>
											</TableContainer>
										)}
									</Form.List>
								</MainCard>
							</Col>

							<Col xs={24}>
								<MainCard content={false} sx={{ overflowX: 'auto', width: '100%', mb: 2 }}>
									<TableContainer
										sx={{
											width: '100%',
											overflowX: 'auto',
											position: 'relative',
											display: 'block',
											'& td, & th': { whiteSpace: 'nowrap' },
											'& td': {
												borderTop: '0px',
												borderLeft: '0px',
												borderBottom: '0px',
											},
											'& td:not(:last-child)': {
												borderRight: '1px solid #e0e0e0',
											},
											'& tr:not(:last-child)': {
												borderBottom: '1px solid #e0e0e0',
											},
											'& th': {
												borderBottom: '1px solid #e0e0e0',
											},
										}}
									>
										<Table
											aria-labelledby="solutionTaskTable"
											sx={{
												'& .MuiTableBody-root .MuiTableCell-root': {
													p: 0.5,
												},
												'& .MuiTableHead-root .MuiTableCell-root': {
													py: 0.5,
													px: 1,
												},
												'& .ant-form-item': {
													marginBottom: 0,
												},
											}}
										>
											<TableHead>
												<TableRow sx={{ backgroundColor: '#e5e5e5' }}>
													<TableCell align="center">Name</TableCell>
													<TableCell align="center">Nominated as</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												<TableRow>
													<TableCell align="center" sx={{ width: '50%' }}>
														<Form.Item name={['secretaryMembers', 'personName']}>
															<Input disabled />
														</Form.Item>
													</TableCell>

													<TableCell align="center" sx={{ width: '50%' }}>
														<Form.Item name={['secretaryMembers', 'nominatedAs']}>
															<Input disabled />
														</Form.Item>
													</TableCell>
												</TableRow>
											</TableBody>
										</Table>
									</TableContainer>
								</MainCard>
							</Col> */}

							<Col xs={24} sm={24} md={12} xl={12}>
								<CustomTextInput
									form={form}
									label="Committee Name"
									name="title"
									size="medium"
									placeholder="Write here"
									disabled={true}
								/>
							</Col>

							<Col xs={24} sm={24} md={12} xl={12}></Col>

							<Col xs={24} sm={24} md={24} xl={24}>
								<Form.Item size="medium" name="purpose" label="Scope of Work / Terms of Reference">
									<Input.TextArea rows={2} placeholder="Write here" disabled={true} />
								</Form.Item>
							</Col>

							<Col xs={24} sm={24} md={12} xl={12}>
								<Form.Item label="Effective From" name="fromDate" getValueProps={(value) => ({ value: value ? dayjs(value) : null })}>
									<DatePicker size="medium" style={{ width: '100%' }} disabled={true} />
								</Form.Item>
							</Col>

							<Col xs={24} sm={24} md={12} xl={12}>
								<Form.Item label="Edited Date" name="toDate" getValueProps={(value) => ({ value: value ? dayjs(value) : null })}>
									<DatePicker style={{ width: '100%' }} disabled />
								</Form.Item>
							</Col>

							<Col xs={24} sm={24} md={24} xl={24}>
								<Typography
									variant="h4"
									sx={{
										fontWeight: 600,
										fontSize: '18px',
										color: '#1a3b5d',
										marginBottom: '16px',
										padding: '0 0 12px 0',
										borderBottom: '1px solid #e0e6ed',
									}}
								>
									Committee Composition
								</Typography>
							</Col>
							{/* <MainCard content={false} sx={{ overflowX: 'auto', width: '100%', mb: 2 }}> */}
							<Form.List name="committeeMembers">
								{(fields) => (
									<TableContainer
										sx={{
											'& td, & th': {
												border: '1px solid rgb(224, 224, 224)',
												p: 1,
											},
											'& .ant-form-item': {
												marginBottom: 0,
											},
											mb: 2,
											px: 1,
										}}
									>
										<Table aria-labelledby="committeeCompositionTable">
											<TableHead sx={{ backgroundColor: 'rgb(246, 245, 245)' }}>
												<TableRow>
													<TableCell align="center" sx={{ minWidth: '50px', width: '3%', fontWeight: 'bold' }}>
														Serial
													</TableCell>

													<TableCell sx={{ minWidth: '180px', width: '18%', fontWeight: 'bold' }}>Committee</TableCell>
													<TableCell sx={{ minWidth: '120px', width: '12%', fontWeight: 'bold' }}>Nominated As</TableCell>
													<TableCell sx={{ minWidth: '180px', width: '12%', fontWeight: 'bold' }}>Role</TableCell>
													<TableCell sx={{ minWidth: '100px', width: '8%', fontWeight: 'bold' }}>
														Approval Sequence
													</TableCell>
													<TableCell sx={{ minWidth: '100px', width: '10%', fontWeight: 'bold' }}>Voting Right</TableCell>
													<TableCell sx={{ minWidth: '100px', width: '10%', fontWeight: 'bold' }}>
														Is Voting Must?
													</TableCell>
													<TableCell sx={{ minWidth: '100px', width: '10%', fontWeight: 'bold' }}>Voting Score</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{fields?.map((field) => (
													<TableRow key={field.key}>
														<TableCell>{field.key + 1}</TableCell>
														<TableCell>
															<Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
																<Form.Item name={[field.name, 'personName']} style={{ margin: 0, flex: 1 }}>
																	<Input size="medium" placeholder="Person name" disabled />
																</Form.Item>
															</Box>
														</TableCell>

														<TableCell>
															<Form.Item name={[field.name, 'nominatedAs']}>
																<Select
																	allowClear
																	size="medium"
																	showSearch
																	style={{ width: '100%' }}
																	placeholder="Select"
																	options={[
																		{ label: 'Position', value: 'positions' },
																		{ label: 'Employee', value: 'users' },
																		{ label: 'Process Role', value: 'processRoles' },
																	]}
																	disabled={true}
																/>
															</Form.Item>
														</TableCell>

														<TableCell>
															<Form.Item name={[field.name, 'positionName']}>
																<Select
																	allowClear
																	showSearch
																	size="medium"
																	style={{ width: '100%' }}
																	placeholder="Select"
																	options={roleList}
																	disabled
																/>
															</Form.Item>
														</TableCell>

														<TableCell>
															<Form.Item name={[field.name, 'serial']}>
																<InputNumber
																	size="medium"
																	min={1}
																	style={{ width: '100%' }}
																	placeholder="Write here"
																	disabled
																/>
															</Form.Item>
														</TableCell>

														<TableCell>
															<Form.Item name={[field.name, 'canVote']}>
																<Select
																	allowClear
																	showSearch
																	size="medium"
																	style={{ width: '100%' }}
																	placeholder="Select"
																	options={[
																		{ label: 'Yes', value: 'yes' },
																		{ label: 'No', value: 'no' },
																	]}
																	disabled
																/>
															</Form.Item>
														</TableCell>

														<TableCell>
															<Form.Item name={[field.name, 'isMandatory']}>
																<Select
																	allowClear
																	showSearch
																	size="medium"
																	style={{ width: '100%' }}
																	placeholder="Select"
																	options={[
																		{ label: 'Yes', value: 'yes' },
																		{ label: 'No', value: 'no' },
																	]}
																	disabled
																/>
															</Form.Item>
														</TableCell>

														<TableCell>
															<Form.Item name={[field.name, 'points']} style={{ margin: 0, flex: 1 }}>
																<Input size="medium" placeholder="Write here" disabled />
															</Form.Item>
														</TableCell>
													</TableRow>
												))}
											</TableBody>
										</Table>
									</TableContainer>
								)}
							</Form.List>
							{/* </MainCard> */}

							<Col xs={24} sm={24} md={12} xl={12}>
								<Form.Item label="Quorum" name="quorum">
									<InputNumber size="medium" min={0} style={{ width: '100%' }} placeholder="Write here" disabled />
								</Form.Item>
							</Col>

							<Col xs={24} sm={24} md={24} xl={24}>
								<Typography
									variant="h4"
									sx={{
										fontWeight: 600,
										fontSize: '18px',
										color: '#1a3b5d',
										marginBottom: '16px',
										padding: '0 0 12px 0',
										borderBottom: '1px solid #e0e6ed',
									}}
								>
									Committee Secretary
								</Typography>
							</Col>

							<Form.List name="committeeSecretary">
								{(fields, fieldsOpt) => (
									<TableContainer
										sx={{
											'& td, & th': { border: '1px solid rgb(224, 224, 224)', p: 1 },
											'& .ant-form-item': {
												marginBottom: 0,
											},
											mb: 2,
											px: 1,
										}}
									>
										<Table aria-labelledby="committeeSecretaryTable">
											<TableHead sx={{ backgroundColor: 'rgb(246, 245, 245)' }}>
												<TableRow>
													<TableCell sx={{ minWidth: '200px', width: '45%' }}>Name</TableCell>
													<TableCell sx={{ minWidth: '150px', width: '45%' }}>Nominated As</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{fields?.map((field) => (
													<TableRow key={field.key}>
														<TableCell>
															<Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
																<Form.Item
																	name={[field.name, 'personName']}
																	style={{ margin: 0, flex: 1 }} // remove default margin + expand input
																>
																	<Input size="medium" placeholder="Person name" disabled />
																</Form.Item>
															</Box>
														</TableCell>

														<TableCell>
															<Form.Item name={[field.name, 'nominatedAs']}>
																<Select
																	allowClear
																	showSearch
																	size="medium"
																	style={{ width: '100%' }}
																	placeholder="Select from the list"
																	options={[
																		{
																			label: 'Position',
																			value: 'positions',
																		},
																		{
																			label: 'Employee',
																			value: 'users',
																		},
																		{
																			label: 'Process Role',
																			value: 'processRoles',
																		},
																	]}
																	disabled
																/>
															</Form.Item>
														</TableCell>
													</TableRow>
												))}
											</TableBody>
										</Table>
									</TableContainer>
								)}
							</Form.List>

							<Col xs={24} sm={24} md={12} xl={12}>
								<Form.Item label="Holding Time Unit" name="holdingTime">
									<InputNumber min={0} size="medium" style={{ width: '100%' }} placeholder="Write here" disabled />
								</Form.Item>
							</Col>

							<Col xs={24} sm={24} md={12} xl={12}>
								<Form.Item label="Holding Time Unit Of Measurements" name="holdingTimeUnit">
									<Select
										allowClear
										showSearch
										size="medium"
										style={{ width: '100%' }}
										placeholder="Select from the list"
										disabled
										options={[
											{
												label: 'Hour (s)',
												value: 'hour',
											},
											{
												label: 'Day (s)',
												value: 'days',
											},
											{
												label: 'Week (s)',
												value: 'week',
											},
											{
												label: 'Month (s)',
												value: 'month',
											},
										]}
									/>
								</Form.Item>
							</Col>

							<Col xs={24} sm={24} md={12} xl={12}>
								<Form.Item label="Approval" name="approval">
									<Radio.Group size="medium" disabled>
										<Radio value="cWin">Chairside wins</Radio>
										<Radio value="cLoss">Chairside losses</Radio>
									</Radio.Group>
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</>
			)}
		</>
	);
}

export default HistoryCom;
